var returnVnd = "https://shopfront-cdn.tekoapis.com/static/c70fd35508218057.svg";

export { returnVnd as default };
